export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/logo.9c2a2023-91f231.png";